<template>
  <div v-cloak ref="auiWrapper" class="ark-container" element-loading-text="拼命加载中">
    <template v-if="!loading">
      <div class="aui-header">
        <div class="top">
          <div class="aui-header__bd" style="background: #1548b1">
            <!-- 1.标题 -->
            <div class="logoArea">
              <img class="logo_img" src="@/assets/layout_dh.png">
              <!-- <img class="logo_img" src="@/assets/layout_gh.png"> -->
              <span>{{logoTitle}}</span>
            </div>
            <!-- 2.科室名称 -->
            <div class="newDepartment">
              {{branchName}}
            </div>
            <!-- 3.工作菜单 -->
            <div class="nav">
              <ul>
                <template v-for="(menus) in routes">
                  <template v-for="(menu, index) in menus.children">
                    <li v-if="!(menu.path === '/basicClue' && branchParentInnerCode.length !== 16)"
                      :class="{'active':currTab === index}" @click="menuChange(index, menu.path)" :key="menu.name">
                      <el-badge :value="cpNumber" :hidden="badgeVisible(menu.path)">
                        <i class="fontFamily" :class="menu.meta.icon"></i>
                        <h4>{{menu.meta.title}}</h4>
                      </el-badge>
                    </li>
                  </template>
                </template>
                <li class="OldClue" v-if="oldMenuList.length>0"
                  :class="{'active':currTab === routes[0].children.length}">
                  <i class="fontFamily" :class="oldMenuList[0].meta.icon"></i>
                  <h4>{{oldMenuList[0].meta.title}}</h4>
                  <span :style="`bottom: -${30*(i+1)}px`" v-for="(item, i) in oldMenuList" :key="item.name"
                    @click="menuChange(routes[0].children.length, item.path)">{{item.meta.title}}</span>
                </li>
              </ul>
            </div>
            <!-- 4.用户信息 -->
            <div class="userArea">
              <div style="text-align: center;">
                <!-- <span style="cursor: pointer;" @click="modifyPNum">{{name}}</span> -->
                <span style="cursor: pointer;">{{name}}</span>
              </div>
              <div class="userArea-row">
                <div class="userArea-row-position">
                </div>
                <div class="userArea-row-position">
                  <div @click="logout">退出</div>
                  <el-dropdown  trigger="click" @command="handleCommand">
                    <span style="color:#fff;">更多</span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="a" icon="el-icon-user-solid">帮助</el-dropdown-item>
                      <el-dropdown-item command="b" icon="el-icon-edit">修改密码</el-dropdown-item>
                      <!-- <el-dropdown-item command="c" icon="el-icon-share">二维码</el-dropdown-item> -->
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
              <!-- <a style="position: absolute;top:70px;" href="http://156.12.0.59:8080/upload/optdoc/处置子平台用户手册.docx" target="view_window">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;下载操作手册</a> -->
              <!-- <a style="position: absolute;top:70px;right: 105px;cursor: pointer;" @click="toHelp()">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;帮助</a> -->
              <!-- <div @click="toHelp()" style="float: right;margin-top: 25px"><router-link to="Help">帮助</router-link></div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="aui-main ark-container-main" :class="{noPadding:isSevenPage}">
        <router-view style="height: 100%;" @judgePage="judgePage" />
      </div>
    </template>

    <!-- A-1 反馈意见部分 -->
    <div class="feedbackOpinion" v-if="opinionShow">
      <div class="closeDiv" @click="closeopinion"><i class="fontFamily el-icon-jw-guanbi"></i></div>
      <el-popover placement="left-start" width="400" trigger="click" v-model="opinionDivShow">
        <div class="opinionDiv" v-if="opinionShow">
          <h3><i class="fontFamily el-icon-jw-xiugai"></i>反馈意见</h3>
          <div>
            <el-form ref="form" :rules="rules" :model="feedbackForm" label-width="80px">
              <el-row>
                <el-col :span="10">
                  <el-form-item label="单位:">
                    <span>{{branchParentName}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="部门:">
                    <span>{{branchName}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="10">
                  <el-form-item label="姓名:">
                    <span>{{name}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="联系电话:" prop="telNumber">
                    <el-input type="text" v-model="feedbackForm.telNumber" maxlength="13" :rows="6"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="意见内容" prop="content">
                <el-input type="textarea" v-model="feedbackForm.content" :rows="6"></el-input>
              </el-form-item>
              <el-form-item label="运维电话">
                <span style="margin-right: 30px;">0571-81051383</span>
                <span>0571-81051320</span>
              </el-form-item>
            </el-form>
          </div>
          <div style="text-align:right;">
            <el-button type="primary" @click="saveOpinion">确定</el-button>
            <el-button @click="opinionDivShow = false">取消</el-button>
          </div>
        </div>
        <el-button slot="reference" type="primary" style="text-align:center;font-size:15px;">
          <i class="fontFamily el-icon-jw-xiugai" style="display:block;font-size:22px;margin-bottom:10px;"></i>
          反馈意见
        </el-button>
      </el-popover>
    </div>
    <!-- A-2 修改资料弹窗 -->
    <el-dialog :visible.sync="modifyPNumVisible" width="500px" top style="margin: 0px; overflow: hidden; padding: 0px;">
      <span slot="title">号码编辑</span>
      <div class="modify_num">
        手机号码：
        <el-input v-model="phoneNum" placeholder="请输入手机号码" style="width:200px" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modifyPNumVisible = false">取 消</el-button>
        <el-button type="primary" @click="updatePhone">确 定</el-button>
      </span>
    </el-dialog>
    <!-- A-3 系统资料弹窗 -->
    <el-dialog title="系统资料" :close-on-click-modal="false" :visible.sync="systemDataBox" width="800px" append-to-body>
      <el-card class="box-card">
        <div v-for="item in systemDatas" :key="item.url">
          <a :href="item.url" :download="item.name">{{item.name}}</a>
          <el-divider></el-divider>
        </div>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button @click="systemDataBox = false">取 消</el-button>
        <el-button type="primary" @click="systemDataBox = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- A-4 修改密码 -->
    <el-dialog title="修改密码" :close-on-click-modal="false" :visible.sync="changePasswordVisible"
      append-to-body>
      <div class="exposeSpan" style="margin-top: 10px">
        <el-form :model="changePassForm" :rules="formRules" ref="changePassForms" label-width="170px">
          <div style="margin-bottom: 10px;">
            <el-form-item label="当前密码：" prop="oldPassword">
              <el-input v-model="changePassForm.oldPassword" type="password" placeholder="当前密码" style="width: 60%">
              </el-input>
            </el-form-item>
          </div>
          <div style="margin-bottom: 10px;">
            <el-form-item label="新密码：" prop="newPassword">
              <el-input v-model="changePassForm.newPassword" type="password" placeholder="新密码" style="width: 60%">
              </el-input>
            </el-form-item>
          </div>
          <div style="margin-bottom: 10px;">
            <el-form-item label="确认密码：" prop="confirmPassword">
              <el-input v-model="changePassForm.confirmPassword" type="password" placeholder="确认密码" style="width: 60%">
              </el-input>
            </el-form-item>
          </div>
          <div style="margin-bottom: 10px;">
            <el-form-item>
              <el-button type="primary" size="medium" @click="submitPassword('changePassForms')"> 修改
              </el-button>
              <el-button type="primary" size="medium" @click="resetForm('changePassForms')"> 重置
              </el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { removeWatermark, setWaterMark } from '@/utils/watermark'
  import { mapGetters } from 'vuex'
  // import Screenfull from '@/components/screenfull'
  import { inputfeedbackOpinion } from '../../api/feedbackOpinion'
  import { selectPhone, updatePhone } from '../../api/layout'
  import { changePassword } from '../../api/login'
  export default {
    name: 'Layout',
    components: {
      // Screenfull
    },
    data() {
      var checkPhone = (rule, value, callback) => {
        const phoneReg = /^1[3|4|5|7|8][0-9]{9}$/
        const reg = /^(\d{3,4}-)?\d{7,8}$/;
        if (value.indexOf(' ') !== -1) {
          return callback(new Error('联系方式不能包含空格'))
        }
        const val = value.trim()
        if (!value) {
          return callback(new Error('联系电话不能为空'))
        }
        setTimeout(() => {
          // Number.isInteger是es6验证数字是否为整数的方法,但是我实际用的时候输入的数字总是识别成字符串
          // 所以我就在前面加了一个+实现隐式转换
          const isTel = reg.test(val);
          if (val.length < 10 || val.length > 13 || !isTel) { // 判断传真字符范围是在10到13
            if (!Number.isInteger(+val)) {
              callback(new Error('请输入数字值'))
            } else {
              if (phoneReg.test(val)) {
                callback()
              } else {
                callback(new Error('手机号格式不正确'))
              }
            }
            callback(new Error('联系电话格式不正确'));
          } else {
            callback();
          }
        }, 100)
      };
      var content = (rule, value, callback) => {
        if (value.trim() === '') {
          callback(new Error('请输入意见内容'))
        } else {
          callback()
        }
      }

      var validatePass = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入密码'));
        } else {
          // if (this.changePassForm.newPassword !== '') {
          //   this.$refs.changePassForms.validateField('confirmPassword')
          // }
          // callback();
          let regex5 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=])[A-Za-z\d@#$%^&+=]{10,}$/g
          if (!regex5.test(value)) {
            callback(new Error('密码必须包含大小写字母，数字和特殊字符(列如:@#$%^&+=)且需大于10位'))
          } else {
            callback()
            if (this.changePassForm.newPassword !== '') {
              this.$refs.changePassForms.validateField('confirmPassword')
            }
          }
        }
      }
      var validatePass2 = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.changePassForm.newPassword) {
          callback(new Error('两次输入密码不一致！'))
        } else {
          callback()
        }
      }

      return {
        rules: {
          telNumber: [{
            require: true,
            message: '请输入',
            trigger: 'blur'
          }, {
            validator: checkPhone
          }],
          content: [{
            require: true,
            message: '请输入',
            trigger: 'blur'
          }, {
            validator: content
          }]
        },
        TITLE: DisciplineConfig.TITLE,
        SUB_TITLE: DisciplineConfig.SUB_TITLE,
        IS_NEIMENG: DisciplineConfig.IS_NEIMENG,
        // 滚动条, 滚动高度
        clientWidth: document.documentElement.clientWidth,
        clientHeight: document.documentElement.clientHeight,
        currTab: 0,
        scrollbarHeight: 0,
        // DOM Element对象
        DOM: {},
        // 加载中
        loading: true,
        // 容器, 居中
        wrapperCenter: false,
        // 头部, 皮肤 (white 白色 / colorful 鲜艳)
        headerSkin: 'colorful',
        // 头部, 固定状态
        headerFixed: false,
        // 侧边, 皮肤 (white 白色 / dark 黑色)
        asideSkin: 'dark',
        // 侧边, 固定状态
        asideFixed: false,
        // 侧边, 折叠状态
        asideFold: true,
        // 侧边, 至头部状态
        asideTop: false,
        // 侧边, 菜单显示状态 (控制台“至头部”操作时, el-menu组件需根据mode属性重新渲染)
        asideMenuVisible: true,
        // 侧边, 菜单选中
        asideMenuActive: 'home',
        // 搜索, 显示状态
        searchVisible: false,
        // 搜索, 值
        search: '',
        // 控制台, 固定状态
        controlFixed: false,
        // 控制台, 打开状态
        controlOpen: false,
        // 控制台, 标签页选中
        controlTabsActive: 'layout',
        // 主内容, 展示类型 (standard 标准 / tabs 标签页)
        mainType: 'standard',
        // 主标签页, 列表
        mainTabs: [],
        // 主标签页, 选中
        mainTabsActive: 'home',
        // 主标签页, 头部固定状态
        mainTabsHeaderFixed: false,
        // 皮肤, 默认值
        skin: 'orange',
        // 皮肤, 列表
        skinList: [
          { name: 'blue', color: '#3E8EF7', remark: '蓝色' },
          { name: 'brown', color: '#997B71', remark: '棕色' },
          { name: 'cyan', color: '#0BB2D4', remark: '青色' },
          { name: 'gray', color: '#757575', remark: '灰色' },
          { name: 'green', color: '#11C26D', remark: '绿色' },
          { name: 'indigo', color: '#667AFA', remark: '靛青色' },
          { name: 'orange', color: '#EB6709', remark: '橙色' },
          { name: 'pink', color: '#F74584', remark: '粉红色' },
          { name: 'purple', color: '#9463F7', remark: '紫色' },
          { name: 'red', color: '#FF4C52', remark: '红色' },
          { name: 'turquoise', color: '#17B3A3', remark: '蓝绿色' },
          { name: 'yellow', color: '#FCB900', remark: '黄色' }
        ],
        indexNoticeTabsActive: '1',
        indexPersonalTabsActive: '1',
        opinionShow: false,
        opinionDivShow: false,
        feedbackForm: {
          title: '',
          content: '',
          telNumber: ''
        },
        phoneNum: '', // 电话号码
        modifyPNumVisible: false,
        oldMenuList: [],
        systemDatas: window.systemFileInside,
        systemDataBox: false,
        changePasswordVisible: false,
        changePassForm: {
          oldPassword: '', // 当前密码
          newPassword: '', // 新密码
          confirmPassword: '' // 确认密码
        },
        formRules: { // 修改密码表单校验
          oldPassword: [{
            required: true,
            message: '当前密码不能为空',
            trigger: 'change'
          }],
          newPassword: [{
            validator: validatePass,
            trigger: 'blur'
          }],
          confirmPassword: [{
            validator: validatePass2,
            trigger: 'blur'
          }]
        },
        cpNumber: 0, // 代办呈批数量
        isSevenPage: false // 七张清单页面不需要内边距
      }
    },
    computed: {
      ...mapGetters([
        'name',
        'branchName',
        'branchParentInnerCode',
        'branchParentName'
      ]),
      routes() {
        global.antRouter.splice(1, 1)
        let data = global.antRouter
        data[0].children.forEach((item, i) => {
          if (item.path === '/OldClue') {
            this.oldMenuList.push(item)
            data[0].children.splice(i, 1)
          }
        })
        data[0].children.forEach((item, i) => {
          if (item.path === '/OldPetition') {
            this.oldMenuList.push(item)
            data[0].children.splice(i, 1)
          }
        })
        console.log(this.oldMenuList.push);
        return data
      },
      logoTitle() {
        return DisciplineConfig.LOGO_TITLE
      },
      IS_OPEN_WEBSITE() {
        return DisciplineConfig.IS_OPEN_WEBSITE;
      },
      badgeVisible() {
        let _this = this;
        // console.log(9999, _this.cpNumber)
        return function(path) {
          return path != '/IntegrityArchives/components/tabl/workDesk' || _this.cpNumber == 0
        }
      }
    },
    mounted() {
      // 因呈批单跳转将此行注释,cp2021
      // this.menuChange(0, '/');

      // 解决刷新页面路由时，工作菜单前台显示未激活
      let data = global.antRouter[0].children;
      data.forEach((item, index) => {
        if (this.$route.path == item.path) {
          this.currTab = index
        }
      });
      let date = new Date()
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    month = (month > 9) ? month : ('0' + month);
    day = (day < 10) ? ('0' + day) : day;
    let today = year + '-' + month + '-' + day;
    let name = this.$store.state.user.name
    let url = DisciplineConfig.base_url
    // setWaterMark(name, url, today)
    },
    watch: {
      '$store.state.workDesk.cpNumber'(val) {
        this.cpNumber = val
      },
      changePasswordVisible(val) {
        if (!val) {
          this.changePassForm.oldPassword = '';
          this.changePassForm.newPassword = '';
          this.changePassForm.confirmPassword = '';
        };
      },
      scrollbarHeight: function(val) {
        this.yLayoutFixedHandle();
      },
      wrapperCenter: function(val) {
        this.headerFixed = false;
        this.asideFixed = false;
        this.controlFixed = false;
        this.mainTabsHeaderFixed = false;
      },
      headerFixed: function(val) {
        this.yLayoutFixedHandle();
      },
      asideFixed: function(val) {
        this.yLayoutFixedHandle();
      },
      asideTop: function(val) {
        this.yLayoutFixedHandle();
        this.asideMenuVisible = false;
        this.$nextTick(function() {
          this.asideMenuVisible = true;
        });
      },
      controlFixed: function(val) {
        this.yLayoutFixedHandle();
      },
      mainTabsHeaderFixed: function(val) {
        this.yLayoutFixedHandle();
      },
      '$route'(val) {
        let data = global.antRouter[0].children // 路由跳转时切换到对应菜单
        data.forEach((item, index) => {
          if (val.path == item.path) {
            this.currTab = index
          }
        })
        // if(val.path == '/IntegrityArchives/components/tabl/workDesk'){
        //   this.currTab = 0
        // } else if(val.path == '/IntegrityArchives/components/tabl/ProblemRectify'){
        //   this.currTab = 1
        // } else if(val.path == '/IntegrityArchives/components/tabl/inspectionWH'){
        //   this.currTab = 2
        // }
      }
    },
    created() {
      this.loading = false;
      this.$nextTick(function() {
        this.scrollbarHandle(true);
        // this.getDOM();
        this.searchHandle();
      });
    },
    methods: {
      judgePage(pageName) {
        if (pageName == 'sevenList') {
          this.isSevenPage = true
        }
      },
      handleCommand(e) {
        if (e == 'a') {
          this.systemDataBox = true
        } else if (e == 'b') {
          this.changePasswordVisible = true
        } else if (e == 'c') {
          window.open('http://10.2.57.215/#/Image','_blank');
        }
      },
      async updatePhone() {
        if (!(/^1[3456789]\d{9}$/.test(this.phoneNum))) {
          return this.$message.error('请输入正确的手机号')
        }
        const res = await updatePhone(this.phoneNum)
        console.log(res)
        if (!res.success) {
          return
        }
        this.$message.success('修改成功')
        this.modifyPNumVisible = false
      },
      async modifyPNum() {
        const res = await selectPhone()
        console.log(res)
        if (!res.success) {
          return
        }
        this.phoneNum = res.data
        this.modifyPNumVisible = true
      },
      logout() {
        if (DisciplineConfig.IS_CAS) {
          window.close()
        } else {
          this.$store.dispatch('LogOut').then(() => {
            this.$router.replace({ path: '/login', query: {} })
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        }
      },
      searchHandle() {},
      scrollbarHandle() {},
      menuChange: function(currTab, url) {
        this.$store.commit('setRouterFlag', false)
        this.currTab = currTab;
        this.$router.push(url);
        console.log(this.$store.state.pzlzClassperson);
        if (this.$store.state.pzlzClassperson.tableData.length > 0) {
          if (this.$store.state.pzlzClassperson.tableData[0].children.length > 0) {
            if (this.$store.state.pzlzClassperson.tableData[0].children[0].children.length > 0) {
              if (this.$store.state.pzlzClassperson.tableData[0].children[0].children[0].children.length > 0) {
                this.$store.commit('setAuditId', this.$store.state.pzlzClassperson.tableData[0].children[0].children[0].children[0].oid)
                this.$store.commit('setTreeOid', this.$store.state.pzlzClassperson.tableData[0].children[0].children[0].children[0].oid)
              }
            }
          }
        }
      },
      // 获取DOM Element对象
      getDOM: function() {
        this.DOM.header = this.$refs.auiWrapper.querySelector('.aui-header');
        this.DOM.aside = this.$refs.auiWrapper.querySelector('.aui-aside');
        this.DOM.control = this.$refs.auiWrapper.querySelector('.aui-control');
        this.DOM.main = this.$refs.auiWrapper.querySelector('.aui-main');
        this.DOM.mainTabsTool = this.DOM.main.querySelector('.aui-main-tabs__tool');
        this.DOM.mainTabsHeader = this.DOM.main.querySelector('.aui-main-tabs > .el-tabs__header');
      },
      // Y轴布局固定
      yLayoutFixedHandle: function() {
        var _offsetHeight = this.scrollbarHeight >= this.DOM.header.offsetHeight ? 0 : this.DOM.header.offsetHeight -
          this.scrollbarHeight;
        // 侧边
        if (!this.headerFixed && this.asideTop && this.asideFixed) {
          this.DOM.aside.style.top = _offsetHeight + 'px';
        } else {
          this.DOM.aside.style.removeProperty('top');
        }
        // 控制台
        if (!this.headerFixed && this.controlFixed) {
          this.DOM.control.style.top = _offsetHeight + 'px';
        } else {
          this.DOM.control.style.removeProperty('top');
        }
        // 主标签页, 头部
        if (!this.headerFixed && this.mainTabsHeaderFixed) {
          if (this.asideTop && this.asideFixed) {
            _offsetHeight += this.DOM.aside.offsetHeight;
          }
          if (this.asideTop && !this.asideFixed) {
            _offsetHeight = this.scrollbarHeight >= this.DOM.header.offsetHeight + this.DOM.aside.offsetHeight ? 0
              : this.DOM.header.offsetHeight + this.DOM.aside.offsetHeight - this.scrollbarHeight;
          }
          if (this.DOM.mainTabsTool) {
            this.DOM.mainTabsTool.style.top = _offsetHeight + 'px';
          }
          if (this.DOM.mainTabsHeader) {
            this.DOM.mainTabsHeader.style.top = _offsetHeight + 'px';
          }
        } else {
          if (this.DOM.mainTabsTool) {
            this.DOM.mainTabsTool.style.removeProperty('top');
          }
          if (this.DOM.mainTabsHeader) {
            this.DOM.mainTabsHeader.style.removeProperty('top');
          }
        }
      },
      // 跳转页面
      gotoPageHandle: function(url) {
        this.$router.push(url);
      },
      //  保存意见
      saveOpinion() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            inputfeedbackOpinion({
              feedbackContent: this.feedbackForm.content, // 意见内容
              feedbackPhonenumber: this.feedbackForm.telNumber, // 联系电话
              feedbackOrgan: this.branchParentName, // 单位
              feedbackDepartment: this.branchName, // 部门
              feedbackPersonName: this.name // 姓名
            }).then(
              res => {
                console.log(res);
                this.feedbackForm.content = ''
                this.feedbackForm.telNumber = ''
              }
            )
            this.opinionDivShow = false;
          }
        })
      },
      //  关闭意见浮窗
      closeopinion() {
        this.opinionShow = false;
      },
      toHelp() { // 去帮助页面
        this.currTab = 999
      },
      // 确认修改密码
      submitPassword(changePassForms) {
        this.$refs[changePassForms].validate((valid) => {
          if (valid) {
            let data = {
              oldPassword: this.changePassForm.oldPassword,
              newPassword: this.changePassForm.newPassword
            }
            changePassword(data).then((response) => {
              let jsonResult = response;
              if (jsonResult.success) {
                this.$message({
                  type: 'success',
                  message: '修改成功!'
                });
                this.changePasswordVisible = false;
                location.reload()
              } else {
                this.$message.error(jsonResult.message);
              }
            }).catch((error) => {
              this.$message.error(error.message);
            })
          } else {
            return false;
          }
        })
      },
      // 重置密码
      resetForm(changePassForms) {
        this.$refs[changePassForms].resetFields()
      },
      amend() {
        this.changePasswordVisible = true;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .el-badge {
    /deep/ .el-badge__content.is-fixed {
      top: 12px;
      right: 30px;
    }
  }
</style>
<style scoped>
  body {
    background: rgb(227, 227, 227);
  }

  .aui-main {
    position: relative;
    min-height: calc(100vh - 50px - 56px);
    margin-left: 230px;
    /* background-color: #E8E8EA; */
    background-color: #fff;
  }

  .aui-control--open .aui-main {
    margin-right: 0;
    min-height: calc(100vh - 50px - 0px);
  }

  .aui-footer {
    height: 0px;
    padding: 0;
  }

  body,
  form,
  div,
  ul,
  ol,
  li,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  table,
  tr,
  th,
  td,
  p,
  input,
  dl,
  dt,
  dd,
  ul,
  ol,
  li,
  input,
  textarea,
  button {
    font-family: microsoft yahei !important;
  }

  img {
    border: none;
  }

  a {
    color: #000;
    text-decoration: none;
  }

  ul {
    list-style: none;
  }

  i {
    font-style: normal;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: normal;
  }

  input,
  select,
  button {
    font-size: 12px;
    vertical-align: middle;
  }

  .top {
    width: 100%;
    height: 90px;
    background: #1548b1;
    position: fixed;
  }

  /* ============== */
  .logoArea {
    height: 90px;
    width: 33%;
    overflow: hidden;
    display: flex;
    user-select: none;
    -ms-user-select: none;
    -webkit-user-select: none;
  }

  .logoArea .logo_img {
    height: 44px;
    margin: 23px 0;
  }

  .logoArea .logo_img:first-child {
    margin-left: 20px;
  }

  .logoArea span {
    margin-left: 10px;
    font-size: 34px;
    line-height: 90px;
    color: #fff;
    white-space: nowrap;
  }

  .newDepartment {
    height: 90px;
    line-height: 90px;
    margin-right: 10px;
    font-size: 25px;
    color: #fff;
    font-weight: bold;
    overflow: hidden;
    user-select: none;
    -ms-user-select: none;
    -webkit-user-select: none;
  }

  /* ============== */
  .top .nav {
    height: 90px;
    margin-left: auto;
  }

  .top .nav ul {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
  }

  .top .nav ul li {
    height: 90px;
    text-align: center;
    cursor: pointer;
    margin-right: 8px;
  }

  .top .nav ul li i {
    font-size: 26px;
    width: auto;
    display: block;
    width: 90px;
    height: 40px;
    font-size: 30px;
    color: #fff;
    margin: 0px auto;
    margin-top: 15px;
  }

  .top .nav ul li h4 {
    min-width: 56px;
    color: #fff;
    font-size: 15px;
  }

  .top .nav ul li:hover {
    background: #6caaf5;
  }

  .top .nav ul li.active {
    background: #6caaf5;
  }

  .top .nav ul li i.nav01 {
    background: url(../../../static/img/icon_nav01.png) no-repeat center;
  }

  .top .nav ul li i.nav02 {
    background: url(../../../static/img/icon_nav02.png) no-repeat center;
  }

  .top .nav ul li i.nav03 {
    background: url(../../../static/img/icon_nav03.png) no-repeat center;
  }

  .top .nav ul li i.nav04 {
    background: url(../../../static/img/icon_nav04.png) no-repeat center;
  }

  .top .nav ul li i.nav05 {
    background: url(../../../static/img/icon_nav05.png) no-repeat center;
  }

  .top .nav ul li i.nav06 {
    background: url(../../../static/img/icon_nav06.png) no-repeat center;
  }

  .top .nav ul li i.nav07 {
    background: url(../../../static/img/icon_nav07.png) no-repeat center;
  }

  /* ============== */
  .userArea {
    padding: 10px 24px 10px 20px;
    width: 100px;
    height: 90px;
    border: 0px solid red;
    font-size: 14px;
    color: #fff;
    line-height: 1.4;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .userArea-row {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 4px;
  }

  .userArea-row-position {
    padding: 0 4px;
    cursor: pointer;
    white-space: nowrap;
  }

  .aui-header {
    position: inherit;
    height: 90px;
    padding: 0;
  }

  .ark-container {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }

  .ark-container-main {
    flex: 1;
    width: 100%;
    padding: 0 10px 0 10px;
    margin: 5px auto;
    overflow: hidden;
  }

  /*反馈意见*/
  .feedbackOpinion {
    position: absolute;
    bottom: 90px;
    right: 10px;
    text-align: center;
    cursor: pointer;
    z-index: 999;
  }

  .feedbackOpinion .closeDiv {
    margin-bottom: 3px;
    overflow: hidden;
  }

  .feedbackOpinion .closeDiv i {
    font-size: 14px;
    color: #999;
    text-align: center;
    padding: 5px 0;
    border: 1px solid #dedede;
    width: 30px;
    float: right;
    margin-bottom: 3px;
    background: #fff;
  }

  .opinionDiv h3 {
    color: #666;
    font-size: 16px;
    border-bottom: 1px solid #ddd;
    height: 40px;
    line-height: 40px;
    margin-bottom: 10px;
  }

  .opinionDiv h3 i {
    font-size: 20px;
    color: #999;
    margin-right: 10px;
  }

  .modify_num {
    margin: 30px 20px;
  }

  .OldClue {
    position: relative;
  }

  .OldClue:hover>span {
    display: block;
  }

  .OldClue:hover>span:hover {
    background-color: rgb(0, 119, 255);
  }

  .OldClue>span {
    display: none;
    position: absolute;
    left: 0;
    width: calc(100% + 20px);
    line-height: 30px;
    background-color: rgb(21, 72, 177);
    color: #fff;
  }

  .noPadding {
    padding: 0 !important;
    margin: 0 auto !important;
  }
</style>
<style>
  .el-radio__inner,
  .el-radio__inner::after {
    border: 1px solid #888 !important;
  }

  .el-checkbox__inner {
    border: 1px solid #888 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue